import styled from "styled-components";

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;
